module.exports = __webpack_public_path__ + "kudos_36.svg?a8d8b7b4dacedca561ae3c5720c9c150";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_36.svg
// module id = 135
// module chunks = 0